/*
 * Copyright (c) 2019. Ratespecial Interactive
 */

export enum BtnActionType {
  LINK = 'link',
  EXT_LINK = 'ext_link',
  MODAL = 'modal',
  SERVICE = 'service',
  AFF_LINK = 'aff_link'
}
